import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MD5CryptoService } from '@app/providers/md5.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from "rxjs/operators";
import { environment } from '@env/environment';
import { Md5 } from 'ts-md5'

interface TranslationEntry {
    orginal_text: string;
    eng_tr_text: string;
    tel_tr_text: string;
    translate_done: boolean;
}
;

@Injectable({
    providedIn: 'root'
})
export class CustomTranslateService {
    private selectedLanguage = new BehaviorSubject<'eng' | 'tel'>('eng'); // Default: USD
    public language$ = this.selectedLanguage.asObservable();
    private hashMap: Map<string, boolean> = new Map<string, boolean>();
    private translations: TranslationEntry[] = [];
    translations$: Observable<TranslationEntry[]> = of([]);
    translateJSONFromFile = [];
    private readonly translationFilePath = 'assets/i18n/server_translate.json';

    constructor(
        private md5Service: MD5CryptoService,
        private http: HttpClient
    ) {
        let oldData = localStorage.getItem('translations');
        if (oldData) {
            const parsed = JSON.parse(oldData);
            if (parsed && parsed.length > 0) {
                const jsonData = JSON.stringify(parsed, null, 2);
                localStorage.setItem('translations', jsonData);
            }
        }

        this.loadTranslationsFromFile(() => {

        });
    }
    setLanguage(language: 'eng' | 'tel') {
        this.selectedLanguage.next(language);
    }

    getLanguage(): 'eng' | 'tel' {
        return this.selectedLanguage.getValue();
    }

    isOnlyNumbers(str: string) {
        return /^[0-9]+$/.test(str);
    }


    addNewTranslation(text: string): void {

        if (!this.isOnlyNumbers(text)) {
            const textHash = this.generateHash(text);
            if (!this.hashMap.has(textHash)) {
                const newEntry: TranslationEntry = {
                    orginal_text: text,
                    eng_tr_text: text,
                    tel_tr_text: '',
                    translate_done: false
                };
                this.translations.push(newEntry);
                this.hashMap.set(textHash, true);
                this.saveTranslationsToFile();
            }
        }


    }

    private generateHash(text: string): string {
        return this.md5Service.getMD5EncryptTxt(text).toString();
    }

    private saveTranslationsToFile(): void {
        // First filter to get only pending translations
        let pendingTranslations = this.translations.filter((item: any) => item.translate_done === false);
        // console.log('Pending translations:', pendingTranslations);
        const jsonData = JSON.stringify(pendingTranslations, null, 2);
        localStorage.setItem('translations', jsonData);
    }

    loadTranslationsFromFile(clbk): void {
        console.log(`Loading translations from ${this.translationFilePath}`);

        this.http.get<any[]>(this.translationFilePath)
            .pipe(
                tap(data => {
                    // console.log('Translation data received:', data);
                }),
                catchError(error => {
                    console.error('Error loading translations:', error);
                    return of([]);
                })
            )
            .subscribe(data => {
                if (data && Array.isArray(data)) {
                    data.filter((k) => {
                        if (k['tel_tr_text']) {
                            k['translate_done'] = true;
                        }
                    })
                    this.translateJSONFromFile = data;
                    // console.log(`Successfully loaded ${data.length} translations from ${this.translationFilePath}`);

                    // Populate the translations and hashMap
                    this.translations = data;

                    // Create the hashmap for quick lookup
                    this.hashMap.clear();
                    this.translations.forEach(entry => {
                        entry['orginal_text_hash'] = Md5.hashStr(entry.orginal_text.toLowerCase())
                        this.hashMap.set(entry['orginal_text_hash'], true);
                    });
                    if (clbk) {
                        clbk();
                    }
                } else {
                    console.warn('Translation data is not in expected format:', data);
                }
            });
    }

}
